// ======================================================================
// File Name       : LiveReservedDetailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import { parseDateForDetail } from '../../utils/index';
import {
  convertLiveFormatType,
  convertLiveRecordingPermission,
} from '../../utils/UsageSettingLiveUtils';

class LiveReservedDetailInfo extends React.Component {
  render() {
    const {
      liveName,
      organizerName,
      liveFormat,
      liveStartFrom,
      liveStartTo,
      selectedUserId,
      storedUserList,
    } = this.props;
    const implementDateTime = `${parseDateForDetail(
      liveStartFrom,
      'YYYY/MM/DD HH:mm',
    )} ～ ${parseDateForDetail(liveStartTo, 'YYYY/MM/DD HH:mm')}`;
    let name = organizerName || '';
    if (selectedUserId && storedUserList && storedUserList[selectedUserId]) {
      name = storedUserList[selectedUserId].userName || '';
    }
    return (
      <div>
        <Form className="col-sm-12">
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">ライブ名</Col>
            <Col sm={7} className="padding-top-bottom-10">{liveName}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">ライブ開催者</Col>
            <Col sm={7} className="padding-top-bottom-10">{name}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">ライブ形式</Col>
            <Col sm={7} className="padding-top-bottom-10">{convertLiveFormatType(liveFormat)}</Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">実施日時</Col>
            <Col sm={7} className="padding-top-bottom-10">{implementDateTime}</Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default LiveReservedDetailInfo;
